module.exports = __webpack_public_path__ + "media/grandmasters.db16e177.mp4";